import React from 'react';
import Section from './Section';
import './Contact.css';

const Contact = () => {
  const socialLinks = [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/lucas-chen-5005aa382/",
      icon: "in"
    },
    {
      name: "Email",
      url: "mailto:lachenakis@gmail.com",
      icon: "@"
    },
    
    {
      name: "Resume (PDF)",
      url: "/Lucas_Chen_Resume.pdf",
      icon: "pdf"
    },
    {
      name: "Portfolio",
      url: "https://lucaschen.ca",
      icon: "web"
    }
  ];

  return (
    <Section
      id="contact"
      title="Connect"
      subtitle="Contact details and resume."
      className="contact-section"
    >
      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-text">
            <h3>Lucas Chen</h3>
            <p>
              Computer Engineering candidate at the University of Waterloo.
              Working in automation, embedded software, and test infrastructure.
            </p>
          </div>

          <div className="contact-details">
            <div className="contact-item">
              <span className="contact-icon" aria-hidden>web</span>
              <div>
                <h4>Website</h4>
                <p><a href="https://lucaschen.ca">lucaschen.ca</a></p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon" aria-hidden>mail</span>
              <div>
                <h4>Email</h4>
                <p><a href="mailto:lachenakis@gmail.com">lachenakis@gmail.com</a></p>
              </div>
            </div>
          </div>

          <div className="contact-cta">
            <a className="btn btn-primary" href="mailto:lachenakis@gmail.com">Email</a>
            <a className="btn btn-secondary" href="/Lucas_Chen_Resume.pdf" target="_blank" rel="noopener noreferrer">View Resume</a>
          </div>
        </div>

        <div className="social-links">
          <h3>Links</h3>
          <div className="social-grid">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label={social.name}
              >
                <span className="social-icon">{social.icon}</span>
                <span className="social-name">{social.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Contact;
